module.exports = __webpack_public_path__ + "img/heart.4efaed65.svg";